<template>
	<slot :is-floating="false"></slot>
	<Teleport to="#navs">
		<div :class="floatingClasses">
			<slot :is-floating="true"></slot>
		</div>
	</Teleport>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { store } from '@js/vue/store.js'

const props = defineProps({
	trigger: {
		type: String,
		default: '#hero'
	}
})

const isVisible = ref(false)
const animate = ref(false)

let ticking = false
let triggerHeight = 0

const floatingClasses = computed(() => {
	const base = 'fixed top-0 inset-x-0 z-40'

	if (!animate.value) {
		return isVisible.value ? base : 'hidden'
	}

	return isVisible.value
		? `${base} transition-transform duration-300`
		: `${base} transition-transform duration-300 -translate-y-full`
})

const getTriggerHeight = () => {
	const el = document.querySelector(props.trigger)
	if (el) triggerHeight = el.offsetHeight
}

const handleScroll = () => {
	if (!ticking && !store.navDrawerOpen) {
		requestAnimationFrame(() => {
			const currentScroll = window.pageYOffset || document.documentElement.scrollTop
			isVisible.value = currentScroll >= triggerHeight
			ticking = false
		})
		ticking = true
	}
}

const handleResize = () => {
	getTriggerHeight()
}

onMounted(() => {
	getTriggerHeight()
	window.addEventListener('resize', handleResize, { passive: true })
	window.addEventListener('scroll', handleScroll, { passive: true })

	requestAnimationFrame(() => {
		getTriggerHeight()
		const currentScroll = window.pageYOffset || document.documentElement.scrollTop
		if (currentScroll >= triggerHeight) {
			isVisible.value = true
		}
		requestAnimationFrame(() => {
			animate.value = true
		})
	})
})

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll)
	window.removeEventListener('resize', handleResize)
})
</script>
